var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1c1.931 0 3.5 1.569 3.5 3.5S9.931 8 8 8a3.502 3.502 0 01-3.5-3.5C4.5 2.569 6.069 1 8 1zm4 10c1.653 0 3 1.347 3 3v1H1v-1c0-1.653 1.347-3 3-3 2.656 0 2.103.5 4 .5 1.903 0 1.34-.5 4-.5zM8 0a4.501 4.501 0 000 9 4.501 4.501 0 000-9zm4 10c-2.887 0-2.219.5-4 .5-1.775 0-1.116-.5-4-.5a4 4 0 00-4 4v1c0 .553.447 1 1 1h14c.553 0 1-.447 1-1v-1a4 4 0 00-4-4z",
    fill: "#5268FB"
  })));
}

export default __webpack_public_path__ + "./fonts/user-alt.118019f55a6899d8223d61cbb54ee784.svg";
export { SvgUserAlt as ReactComponent };